import { render, staticRenderFns } from "./info-box.vue?vue&type=template&id=374b982c&"
import script from "./info-box.vue?vue&type=script&lang=js&"
export * from "./info-box.vue?vue&type=script&lang=js&"
import style0 from "./info-box.vue?vue&type=style&index=0&id=374b982c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports